import type { Route } from '@angular/router';
import { exclusionRoutes } from './resource-opening-hour-exclusion/exclusion.routes';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { reservationRoutes } from './resource-reservation/reservation.routes';

export const resourceRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/resource-list.component').then(
        ({ ResourceListComponent }) => ResourceListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'exclusion',
    children: exclusionRoutes,
    title: 'PAGES.RESOURCE_OPENING_HOUR_EXCLUSION.BREADCRUMB.LIST',
  },
  {
    path: 'reservation',
    children: reservationRoutes,
    title: 'PAGES.RESOURCE_RESERVATION.BREADCRUMB.LIST',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/resource-details.component').then(
        ({ ResourceDetailsComponent }) => ResourceDetailsComponent,
      ),
    title: 'PAGES.RESOURCE.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.RESOURCE.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/resource-details.component').then(
        ({ ResourceDetailsComponent }) => ResourceDetailsComponent,
      ),
    title: 'PAGES.RESOURCE.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.RESOURCE.SINGULAR'),
      ]),
    ],
  },
];
